// Import environment-specific configurations
import developmentConfig from './config.development';
import productionConfig from './config.production';
import { getEnvironment } from '../utils/environment';

// Determine which configuration to use based on the environment
const env = getEnvironment();
const config = env === 'production' ? productionConfig : developmentConfig;

// Export the configuration
export default config; 